const YOUTUBE_API_KEY = 'AIzaSyCAqzDBjANmHVcO-8TWuks3831DhQSyTDE'; // Remplacez par votre clé API

export const youtubeService = {
    // Récupérer les statistiques d'une vidéo
    async getVideoStats(videoId) {
        try {
            const response = await fetch(
                `https://www.googleapis.com/youtube/v3/videos?part=statistics,snippet,contentDetails&id=${videoId}&key=${YOUTUBE_API_KEY}`
            );

            if (!response.ok) {
                throw new Error('Erreur lors de la récupération des données YouTube');
            }

            const data = await response.json();

            if (data.items && data.items.length > 0) {
                const video = data.items[0];
                return {
                    viewCount: parseInt(video.statistics.viewCount) || 0,
                    likeCount: parseInt(video.statistics.likeCount) || 0,
                    commentCount: parseInt(video.statistics.commentCount) || 0,
                    duration: video.contentDetails.duration,
                    title: video.snippet.title,
                    description: video.snippet.description,
                    publishedAt: video.snippet.publishedAt
                };
            }

            return null;
        } catch (error) {
            console.error('Erreur YouTube API:', error);
            return null;
        }
    },

    // Récupérer les stats de plusieurs vidéos en une seule requête
    async getMultipleVideosStats(videoIds) {
        try {
            const ids = videoIds.join(',');
            const response = await fetch(
                `https://www.googleapis.com/youtube/v3/videos?part=statistics&id=${ids}&key=${YOUTUBE_API_KEY}`
            );

            if (!response.ok) {
                throw new Error('Erreur lors de la récupération des données YouTube');
            }

            const data = await response.json();

            const statsMap = {};
            if (data.items) {
                data.items.forEach(item => {
                    statsMap[item.id] = {
                        viewCount: parseInt(item.statistics.viewCount) || 0,
                        likeCount: parseInt(item.statistics.likeCount) || 0
                    };
                });
            }

            return statsMap;
        } catch (error) {
            console.error('Erreur YouTube API:', error);
            return {};
        }
    },

    // Convertir la durée ISO 8601 en format lisible (PT15M30S -> 15:30)
    formatDuration(isoDuration) {
        const match = isoDuration.match(/PT(\d+H)?(\d+M)?(\d+S)?/);

        const hours = (match[1] || '').replace('H', '');
        const minutes = (match[2] || '').replace('M', '');
        const seconds = (match[3] || '').replace('S', '');

        const parts = [];
        if (hours) parts.push(hours);
        parts.push(minutes || '0');
        parts.push(seconds.padStart(2, '0') || '00');

        return parts.join(':');
    },

    // Formater le nombre de vues (1234567 -> 1.2M)
    formatViewCount(count) {
        if (count >= 1000000) {
            return (count / 1000000).toFixed(1) + 'M';
        } else if (count >= 1000) {
            return (count / 1000).toFixed(1) + 'K';
        }
        return count.toString();
    }
};